require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./ar-eg-update-شكوى-المجتمع-المدني-المصري-ضد-شركة-اسمنت-مجموعة-تيتان.json") })
        }
      }, "path---ar-eg-update-شكوى-المجتمع-المدني-المصري-ضد-شركة-اسمنت-مجموعة-تيتان");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---ar-eg-update-شكوى-المجتمع-المدني-المصري-ضد-شركة-اسمنت-مجموعة-تيتان!./.cache/json/ar-eg-update-شكوى-المجتمع-المدني-المصري-ضد-شركة-اسمنت-مجموعة-تيتان.json
// module id = 461
// module chunks = 231608221292675